import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import apiClient from '../api/apiClient';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [myAccounts, setMyAccounts] = useState(null);

  const fetchMe = useCallback(async () => {
    try {
      const res = await apiClient.get('/auth/me');
      setUser(res.data.user);
      // Load accounts after auth
      try {
        const acctRes = await apiClient.get('/auth/my-accounts');
        setMyAccounts(acctRes.data);
      } catch {
        setMyAccounts(null);
      }
    } catch {
      setUser(null);
      setMyAccounts(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (email, password) => {
    const res = await apiClient.post('/auth/login', { email, password });
    setUser(res.data.user);
    // Load accounts after login
    try {
      const acctRes = await apiClient.get('/auth/my-accounts');
      setMyAccounts(acctRes.data);
    } catch {
      setMyAccounts(null);
    }
    return res.data.user;
  };

  const logout = async () => {
    await apiClient.post('/auth/logout');
    setUser(null);
    setMyAccounts(null);
  };

  const switchAccount = async (accountId) => {
    await apiClient.post('/auth/switch-account', { account_id: accountId });
    // Full page reload to reset all data under the new account context
    window.location.reload();
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refetchUser: fetchMe, myAccounts, switchAccount }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
